import { Api } from '@/services/Api'

export default {
  getEventLog(param) {
    return Api().post('/api/v1.0/alert', param)
  },
  getAlertList(plantId, dateFrom, dateTo, status, devices) {
    return Api().get(`/api/v1.0/alert/${plantId}/${dateFrom}/${dateTo}/${status}/${devices}`)
  },
  getAlertListV2(plantId, dateFrom, dateTo, status, devices, severity, info) {
    return Api().get(`/api/v2/alert/list/${plantId}/${devices}/${dateFrom}/${dateTo}/${severity}/${status}/${info}`, { timeout: 5000 })
  },
  getManualAlertListV2(plantId, equipment, scope, identifier, timeOrdate, timeTO, page, totalResult) {
    let obj = {
      page: page,
      totalResult: totalResult
    }
    const info = Buffer.from(
      JSON.stringify(obj)
    ).toString('base64')
    return Api().get(`/api/v2/alert/manual-alert/${plantId}/${equipment}/${scope}/${identifier}/${timeOrdate}/${timeTO}/${info}`, { timeout: 4500 })
  },
  downloadAlertList(plantId, plantName, dateFrom, dateTo, status, devices) {
    return Api().request({
      url: `/api/v1.0/alert/list-opt/${plantId}/${dateFrom}/${dateTo}/${status}/${devices}`, // your url
      method: 'GET',
      responseType: 'blob' // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${plantName}-${devices} alert.csv.gz`) //or any other extension
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    })
  },

  downloadAlertListV2(plantId, plantName, dateFrom, dateTo, status, devices, severity) {
    return Api().request({
      url: `/api/v2/alert/download/${plantId}/${devices}/${dateFrom}/${dateTo}/${severity}/${status}`, // your url
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${plantName}-${devices} alert.csv.gz`) //or any other extension
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    })
  },

  updateStatus(param) {
    return Api().put('/api/v1.0/alert/update', param)
  },
  updateStatusV2(param) {
    return Api().put('/api/v2/alert/update', param)
  },
  createGridAlert(param) {
    return Api().post('/api/v1.0/alert/grid', param)
  },

  // TEP home page alerts
  getActiveAlert(param) {
    return Api().post(`/api/v2/alert/activeAlert`, param)
  }
}
